<template>
  <v-container>
    <v-container>
      <div>
        <v-row class="pt-6">
          <v-col cols="12">
            <h1 class="text-primary">Shock Simulator (SIM)</h1>
          </v-col>
          <v-col cols="12">
            <h4 class="text-primary">
              Forecast the short-run responses of BOLSA, NER, and CDS to
              hypothetical shocks of your own design involving discrete changes
              in domestic and/or foreign macroeconomic variables including SPX
              or, alternatively, allow SPX to be endogenous and forecast this
              indicator’s responses to changes in international macro variables.
              For specific instructions, look
              <a href="#" @click="dialog = true">Here</a> .
            </h4>
            <div>
              <v-dialog v-model="dialog" width="auto" scrollable>
                <v-card>
                  <v-card-text style="height: 500px; overflow-y: scroll">
                    <div>
                      <h4 class="text-primary">
                        Unlike MTF, the forecasting time horizon is four weeks in this case,
                        and the input table is empty except for the first
                        column, which has last week’s observed input values.
                        Click <b> Apply </b>without making any changes and the
                        platform will devolve four-week forecasts of CDS, NER,
                        and BOLSA that assume that the macro inputs are the same in weeks
                        1 to 4 as they were last week. These are baseline or
                        before-the-shock forecasts. To simulate the effect of a
                        shock involving discrete changes in one or more
                        exogenous variables, enter the corresponding values for
                        weeks 1 to 4. To facilitate filling the input table,
                        H2F2 reads an empty cell as meaning that there is no
                        change relative to the previous cell. To visualize the
                        effect of the shock, click <b>Chart</b> and choose the variable
                        you want to see. The chart will show the corresponding
                        four-week forecast before and after the shock. To
                        endogenize SPX, go back to the input table and click the
                        button at the top.
                        <br />
                        <br />
                        Important: H2F2 is a proprietary product of Janus4cast LLC for which a USPTO patent is pending.
                        Reproducing graphical and/or numerical results obtained by using this tool requires citing
                        www.janus4cast.com as the primary source.
                      </h4>
                    </div>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn color="primary" @click="dialog = false">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12"> </v-col>
          <v-col cols="12"> </v-col>
          <v-col cols="12"> </v-col>
          <v-col cols="2">
            <select
              name="LeaveType"
              @change="onChange($event)"
              class="form-control minimal"
              v-model="value"
            >
              <option
                v-for="item in getcontriesConsensusFilter"
                :value="item"
                v-bind:key="item.name"
              >
                {{ item.name }}
              </option>
            </select>
          </v-col>
          <v-col cols="8">
            <v-switch
              v-model="endogenous"
              class="mt-6 pt-3"
              value="true"
              color="primary"
              label="Endogenize SPX"
            ></v-switch>
          </v-col>
          <v-col cols="2">
            <v-row justify="end" align="end">
              <v-btn
                @click="reload"
                class="mr-3"
                icon="mdi-reload"
                small
                color="primary"
              ></v-btn>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-card contained-text variant="outlined">
              <v-table calculate-widths>
                <thead>
                  <tr>
                    <th class="text-center">Indicator</th>
                    <th
                      v-for="item in header[0]"
                      v-bind:key="item"
                      class="text-center"
                    >
                      {{ item }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, indexD) in desserts" :key="item.name">
                    <td v-if="item.header" class="text-left lx-row-group">
                      {{ item.name }}
                    </td>
                    <td
                      v-if="!item.header"
                      class="text-left"
                    >
                      <div style="width: 225px">
                        {{ item.name }}
                      </div>
                    </td>
                    <td
                      v-for="a in item.data"
                      v-show="item.header"
                      v-bind:key="a"
                      class="text-center lx-row-group"
                    ></td>
                    <td
                      v-for="(value, index) in item.data"
                      v-show="!item.header"
                      v-bind:key="value"
                      class="text-center"
                    >
                      <input
                        with="50%"
                        type="number"
                        step="0.1"
                        style="text-align: center; width: 120px"
                        :value="item.data[index]"
                        :disabled="index == 0 || item.disable"
                        @change="updateValue($event, indexD, index)"
                      />
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="end">
          <v-col cols="12"></v-col>
          <v-btn
            v-show="!getLoadingApplyShortTerm"
            @click="sendData"
            rounded
            class="elevation-0 mr-3"
            color="var(--bg-2)"
          >
            Apply</v-btn
          >
          <v-progress-circular
            v-show="getLoadingApplyShortTerm"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-row>
        <v-row v-show="header2.length > 0">
          <v-col cols="6">
            <v-row>
              <v-col cols="12">
                <h1 class="text-primary">Short Term Forecast Results</h1>
              </v-col>
              <v-col cols="12">
                <h4 class="text-primary">
                  Period: {{ datePeriod[0] + " - " + datePeriod[1] }}.
                </h4>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row justify="end">
              <v-col cols="12"></v-col>
              <v-col cols="9" xl="9" md="8" class="pt-0">
                <v-row justify="end">
                  <v-col cols="6" xl="6" md="10">
                    <select
                      v-show="!table"
                      name="LeaveType"
                      @change="onChange2($event)"
                      class="form-control minimal"
                      v-model="value3"
                    >
                      <option
                        v-for="item in value3Opcions"
                        :value="item"
                        v-bind:key="item"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3" xl="3" md="4" class="text-right">
                <v-row justify="end">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" class="py-1 text-right">
                        <div class="lx-seg">
                          <button type="button" class="lx-seg__btn"
                            :class="{ 'lx-seg__btn--on': !table }"
                            @click="table = false">Chart</button>
                          <button type="button" class="lx-seg__btn"
                            :class="{ 'lx-seg__btn--on': table }"
                            @click="table = true">Table</button>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" v-if="showResult">
            <v-card contained-text variant="outlined">
              <v-table calculate-widths>
                <thead>
                  <tr>
                    <th class="text-center">Indicator</th>
                    <th
                      v-for="item in header2"
                      v-bind:key="item"
                      class="text-center"
                    >
                      {{ item }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in desserts2" :key="item.name">
                    <td v-if="item.header" class="text-left lx-row-group">
                      {{ item.name }}
                    </td>
                    <td
                      v-if="!item.header"
                      class="text-left"
                    >
                      <div style="width: 225px">
                        {{ item.name }}
                      </div>
                    </td>
                    <td
                      v-for="a in item.data"
                      v-show="item.header"
                      v-bind:key="a"
                      class="text-center lx-row-group"
                    ></td>
                    <td
                      v-for="value in item.data"
                      v-show="!item.header"
                      v-bind:key="value"
                      class="text-center"
                    >
                      {{ new Intl.NumberFormat("en-US").format(value) }}
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-card>
          </v-col>
          <v-col cols="12" v-show="!table && header2.length > 0">
            <v-row justify="center">
              <v-col cols="12">
                <div class="lx-legend mb-3">
                  <span class="lx-legend__item"><span class="lx-legend__swatch lx-legend__swatch--hist"></span>Observed</span>
                  <span class="lx-legend__item"><span class="lx-legend__swatch lx-legend__swatch--alt"></span>Shocked scenario</span>
                  <span class="lx-legend__item"><span class="lx-legend__swatch lx-legend__swatch--fcst"></span>Baseline</span>
                </div>
                <div id="container" style="width: 100%; height: 420px"></div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="2" v-show="header2.length > 0">
            <v-btn
              @click="saveCsv()"
              rounded
              class="elevation-0"
              color="primary"
              >download</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import anychart from "anychart";
import $ from "jquery";

export default {
  name: "short-term",
  components: {},
  data() {
    return {
      value: {},
      items: [
        {
          name: "Brazil",
          consensusReport: "Brazil - Consensus",
        },
        {
          name: "Chile",
          consensusReport: "Chile - Consensus",
        },
      ],
      desserts: [],
      labels: ["12am", "3am", "6am", "9am", "12pm", "3pm", "6pm", "9pm"],
      value2: [200, 675, 410, 390, 310, 460, 250, 240],
      period: "01/07/2020 - 31/07/2020",
      table: false,
      header: [],
      header2: [],
      desserts2: [],
      value3: "Local 1Y rate",
      value3Opcions: [],
      datePeriod: ["", ""],
      last_semester: [],
      shock_result: [],
      shock_result_endogenize: [],
      endogenous: false,
      save: false,
      dialog: false,
    };
  },
  computed: {
    ...mapGetters([
      "getcontriesConsensus",
      "getDataShortTerm",
      "getdataConsensusResult",
      "getShortTermResult",
      "getUrlExportShortTerm",
      "getLoadingApplyShortTerm",
      "getLastSemester",
      "getDataShortTermResult",
      "getDataShortTermResultEndogenize",
    ]),
    dataFormated() {
      let data = this.desserts2;
      let header = this.header2;
      let dataFormated = [];
      for (let i = 0; i < header.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if (data[j].name == this.value3) {
            dataFormated.push([header[i], data[j].data[i]]);
          }
        }
      }

      return dataFormated;
    },

    showResult() {
      return this.header2.length > 0 && this.table;
    },
    getcontriesConsensusFilter: function () {
      return this.getcontriesConsensus.filter((i) => i.forecastFilter === true);
    },
    lastSemesterFormated() {
      let data = this.last_semester;
      let dataFormated = [];
      if (data[this.value3] != undefined) {
        for (let i = 0; i < Object.keys(data[this.value3]).length; i++) {
          dataFormated.push([
            Object.keys(data[this.value3])[i],
            data[this.value3][Object.keys(data[this.value3])[i]].toFixed(2),
          ]);
        }
      }

      return dataFormated;
    },
    shockResult() {
      let data = this.shock_result;
      let dataFormated = [];
      if (data[this.value3] != undefined) {
        for (let i = 0; i < Object.keys(data[this.value3]).length; i++) {
          dataFormated.push([
            Object.keys(data[this.value3])[i],
            data[this.value3][Object.keys(data[this.value3])[i]].toFixed(2),
          ]);
        }
      }
      return dataFormated;
    },
    shockResultEndogenize() {
      let data = this.shock_result_endogenize;
      let dataFormated = [];
      if (data[this.value3] != undefined) {
        for (let i = 0; i < Object.keys(data[this.value3]).length; i++) {
          dataFormated.push([
            Object.keys(data[this.value3])[i],
            data[this.value3][Object.keys(data[this.value3])[i]].toFixed(2),
          ]);
        }
      }
      return dataFormated;
    },
  },
  methods: {
    ...mapActions([
      "setCountriesConsensus",
      "setDataShortTerm",
      "appleyShortTerm",
      "exportExcelShortTerm",
      "setDataLastSemester",
      "setDataShortTermResult",
      "setDataShortTermResultEndogenize",
    ]),
    reload() {
      this.setDataShortTerm(this.value.consensusReport);
    },

    onChange() {
      this.setDataShortTermResult(this.value.consensusReport);
      this.setDataShortTermResultEndogenize(this.value.consensusReport);
      this.setDataShortTerm(this.value.consensusReport);
    },

    sendData() {
      let data = {
        country: this.value.forecastTool,
        data: [],
        endogenous: this.endogenous,
      };
      for (let i = 0; i < this.desserts.length; i++) {
        if (!this.desserts[i].header) {
          let item = { key: this.desserts[i].name, values: [] };
          for (let j = 0; j < this.desserts[i].data.length; j++) {
            item.values.push({
              header: this.header[0][j],
              value: this.desserts[i].data[j],
            });
          }
          data.data.push(item);
        }
      }
      this.appleyShortTerm(JSON.stringify(data).replaceAll("\\", ""));
    },
    updateValue(val, indexD, index) {
      this.desserts[indexD].data[index] = val.target.value;
      console.log(this.desserts[indexD]);
      console.log(this.desserts[indexD].data[index]);
      if (
        this.value.name == "China" &&
        this.desserts[indexD].name == "Real GDP growth (% yoy)"
      ) {
        this.desserts.map((x) => {
          if (x.name == "China GDP growth (% yoy)") {
            x.data[index] = val.target.value;
          }
        });
      }
      if (
        this.value.name == "China" &&
        this.desserts[indexD].name == "China GDP growth (% yoy)"
      ) {
        this.desserts.map((x) => {
          if (x.name == "Real GDP growth (% yoy)") {
            x.data[index] = val.target.value;
          }
        });
      }
    },

    saveCsv() {
      if (this.table) {
        let header = [];
        let header2 = [];
        for (let i = 0; i < this.header[0].length; i++) {
          header.push(this.header[0][i]);
        }
        for (let i = 0; i < this.header2.length; i++) {
          header2.push(this.header2[i]);
        }

        this.exportExcelShortTerm({
          data: JSON.stringify(this.desserts),
          headers: header,
          data2: JSON.stringify(this.desserts2),
          headers2: header2,
        });
      } else {
        this.savePng();
      }
    },
    onChange2() {
      this.drawChar();
    },

    drawChar() {
      let data = this.dataFormated;
      let label = this.value3;
      let data_last_semester = this.lastSemesterFormated;
      let data_shock_result = this.endogenous
        ? this.shockResult
        : this.shockResultEndogenize;
      var chart = "";
      $("#container").html("");
      anychart.onDocumentReady(function () {
        // create a pie chart
        chart = anychart.line();
        chart.tooltip().useHtml(true);

        var data3 = chart.line(data_last_semester);
        data3.name("Past Data");
        data3.stroke({ color: "#0d1420", thickness: 2 });
        data3
          .tooltip()
          .format(
            "<span style='color:#0d1420'><b>Past Data: {%Value}</b></span>"
          );

        var data1 = chart.line(data);
        data1.name("After-Shock Fcst");
        data1.stroke({ color: "#0b8f6a", thickness: 2, dash: "6 4" });
        data1
          .tooltip()
          .format(
            "<span style='color:#0b8f6a'><b>After-Shock Fcst: {%Value}</b></span>"
          );

        var data2 = chart.line(data_shock_result);
        data2.name("Before-Shock Fcst");
        data2.stroke({ color: "#2563b8", thickness: 2, dash: "6 4" });
        data2
          .tooltip()
          .format(
            "<span style='color:#2563b8'><b>Before-Shock Fcst: {%Value}</b></span>"
          );

        // auto-scale the y-axis tightly to the data range so the before/after
        // shock difference is visible instead of flattened by a fixed axis.
        chart.yScale().minimumGap(0.1).maximumGap(0.1);

        // same research-grade chrome as the MTF chart: the panel header carries
        // the title; hairline axes, muted grid, monospace ticks, crosshair.
        chart.title(false);
        chart.background().fill("#ffffff");
        chart.padding([8, 8, 4, 0]);
        chart.yAxis().stroke("#dbe1ea");
        chart.xAxis().stroke("#dbe1ea");
        chart.yAxis().ticks(false);
        chart.xAxis().ticks().stroke("#dbe1ea");
        chart.yAxis().labels().fontFamily("JetBrains Mono").fontSize(10).fontColor("#94a0b4");
        chart.xAxis().labels().fontFamily("JetBrains Mono").fontSize(10).fontColor("#94a0b4");
        chart.yGrid().enabled(true).stroke("#e8ecf2");
        chart.xGrid().enabled(false);
        chart.crosshair().enabled(true).yLabel(false).yStroke(null);
        chart.crosshair().xStroke("#c3ccd9", 1, "3 3");
        chart.legend().enabled(true).fontSize(11)
          .fontFamily("JetBrains Mono").fontColor("#626e88")
          .padding([0, 0, 12, 0]).iconSize(11);
        chart.tooltip().fontFamily("JetBrains Mono").fontSize(11)
          .background().fill("#0d1420").stroke(null);

        // set the container where chart will be drawn
        chart.container("container");
        //  draw the chart on the page
        chart.draw();
      });
      if (this.save) {
        chart.saveAsPng({
          width: 1000,
          height: 500,
          quality: 0.3,
          filename: "Medium-Term Forecast Tool " + label,
        });
        this.save = false;
      }
    },
    savePng() {
      this.save = true;
      this.drawChar();
    },
  },
  watch: {
    value: function () {
      this.setDataShortTerm(this.value.consensusReport);
      this.setDataShortTermResult(this.value.consensusReport);
      this.setDataShortTermResultEndogenize(this.value.consensusReport);
      this.setDataLastSemester(this.value.consensusReportResult);
    },
    getcontriesConsensus: function (val) {
      // default to the first country the dropdown actually lists
      if (val && val.length) this.value = this.getcontriesConsensusFilter[0] || val[0];
    },
    getDataShortTerm: function (val) {
      let data = JSON.parse(val);
      this.desserts = [];
      if (Object.keys(data).length > 0) {
        this.header = [];

        this.header.push(Object.keys(data));

        let name = Object.keys(data[this.header[0][0]]);

        let newData = [];

        for (let i = 0; i < name.length; i++) {
          let obj = {};
          obj.name = name[i];
          obj.data = [];
          obj.header = false;
          for (let j = 0; j < this.header[0].length; j++) {
            if (data[this.header[0][j]][name[i]] != null)
              obj.data.push(data[this.header[0][j]][name[i]].toFixed(2));
            else obj.data.push(data[this.header[0][j]][name[i]]);

            if (data[this.header[0][j]][name[i]] == null) {
              obj.header = true;
            }
          }
          for (let j = 0; j < obj.data.length; j++) {
            if (obj.data[j] != null) {
              for (let j = 0; j < obj.data.length; j++) {
                if (obj.data[j] == null) {
                  obj.data[j] = null;
                }
              }
              obj.header = false;
              break;
            }
          }
          newData.push(obj);
        }
        newData.join();
        this.desserts = newData;
      }
    },
    getShortTermResult: function (val) {
      if (val.length > 0) {
        val = val.substr(1, val.length - 2);
        let data = JSON.parse(val);
        if (Object.keys(data).length > 0) {
          this.header2 = [];
          let newHeader = [];
          for (
            let i = 0;
            i < Object.keys(data[Object.keys(data)[0]]).length;
            i++
          ) {
            newHeader.push(Object.keys(data[Object.keys(data)[0]])[i]);
          }
          this.header2 = newHeader;
          let newData = [];

          for (let j = 0; j < Object.keys(data).length; j++) {
            let obj = {};
            obj.name = Object.keys(data)[j];
            obj.data = [];
            obj.header = false;
            for (let i = 0; i < this.header2.length; i++) {
              if (data[Object.keys(data)[j]][this.header2[i]] == null) {
                obj.data.push(0);
              } else {
                obj.data.push(
                  data[Object.keys(data)[j]][this.header2[i]].toFixed(2)
                );
              }
            }
            newData.push(obj);
          }
          this.desserts2 = newData;
          let nuw_value = [];
          for (let i = 0; i < this.desserts2.length; i++) {
            nuw_value.push(this.desserts2[i].name);
          }
          this.value3Opcions = nuw_value;
          this.value3 = this.value3Opcions[0];

          this.datePeriod[0] = this.header2[0].replaceAll("-", "/");
          this.datePeriod[1] = this.header2[this.header2.length - 1].replaceAll(
            "-",
            "/"
          );
          this.drawChar();
        }
      }
    },
    getUrlExportShortTerm: function (val) {
      if (val != "") {
        window.open(val, "_blank");
      }
    },
    getLastSemester: function (val) {
      let data = JSON.parse(val);
      this.last_semester = data;
    },
    endogenous: function (val) {
      this.desserts.map((x) => {
        if (x.name == "USA - S&P500") {
          x.disable = val;
        } else x.disable = false;
      });
    },
    getDataShortTermResult: function (val) {
      let data = JSON.parse(val);
      this.shock_result = data;
    },
    getDataShortTermResultEndogenize: function (val) {
      let data = JSON.parse(val);
      this.shock_result_endogenize = data;
    },
  },
  mounted() {
    // countries may already be loaded by another page (watcher won't fire)
    if (this.getcontriesConsensusFilter.length) {
      this.value = this.getcontriesConsensusFilter[0];
    }
    this.setCountriesConsensus();
  },
  created() {
    console.log("forecast");
  },
};
</script>
<style scoped>
/* NOTE: this block used to be unscoped and restyled every table in the app
   (bold OpenSans navy cells), fighting the design system. It is now scoped and
   limited to what is structural here: a frozen indicator column. */
table > thead > tr > th {
  min-width: 96px;
}

table > tbody > tr > td:nth-child(1),
table > thead > tr > th:nth-child(1) {
  position: sticky;
  left: 0;
  z-index: 1;
  min-width: 220px;
  box-shadow: inset -1px 0 0 var(--line);
}
table > tbody > tr > td:nth-child(1) { background: var(--bg-1); }
table > thead > tr > th:nth-child(1) { background: var(--bg-2); }
table > tbody > tr > td.lx-row-group:nth-child(1) { background: var(--bg-2); }
v-input__details {
  margin: 0%;
}

select.minimal {
  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%),
    linear-gradient(to right, #ccc, #ccc);
  background-position: calc(100% - 20px) calc(1em + 2px),
    calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
}

select.minimal:focus {
  background-image: linear-gradient(45deg, green 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, green 50%),
    linear-gradient(to right, #ccc, #ccc);
  background-position: calc(100% - 15px) 1em, calc(100% - 20px) 1em,
    calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
  border-color: green;
  outline: 0;
}

select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>